import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { User } from '@/Domain/api/User/dto/User.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class AiApi {
  static getUsers = (): Promise<User[]> =>
    httpClient.get(Endpoint.ai.users).then(ApiMapper.toResponseData);

  static getAssistant = () => httpClient.get(Endpoint.ai.assistant).then(ApiMapper.toResponseData);
}
